import axios from 'axios'
// import { getToken } from '@/utils/auth'
import db from './localstorage.js'
import config from './config'




function getToken() {
  return db.get('token')
}
const mimeMap = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  zip: 'application/zip',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  oss: 'application/octet-stream'
}
var baseUrl = null
if (process.env.NODE_ENV === 'development') { //本地
  baseUrl = config.apiUrltest

} else if (process.env.NODE_ENV === 'production') { //线上
  baseUrl = config.apiUrl
}
export function downLoadZip(str, filename) {
  var url = baseUrl + str
  axios({
    method: 'get',
    url: url,
    responseType: 'blob',
    headers: { 'Authorization': 'Bearer ' + getToken() }
  }).then(res => {
    resolveBlob(res, mimeMap.zip)
  })
}

export function downLoadOss(ossId) {
  var url = baseUrl + '/system/oss/download/' + ossId
  axios({
    method: 'get',
    url: url,
    responseType: 'blob',
    headers: { 'Authorization': 'Bearer ' + getToken() }
  }).then(res => {
    resolveBlob(res, mimeMap.oss)
  })
}

export function downLoadWord(url, params, method, func) {
  if (method === 'get') {
    // 若还是get 处理传参 查询字符串
    let urlparams = url + '?';
    for (const propName of Object.keys(params)) {
      const value = params[propName];
      var part = encodeURIComponent(propName) + "=";
      if (value !== null && typeof (value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            if (value[key] !== null && typeof (value[key]) !== 'undefined') {
              let params = propName + '[' + key + ']';
              let subPart = encodeURIComponent(params) + '=';
              urlparams += subPart + encodeURIComponent(value[key]) + '&';
            }
          }
        } else {
          urlparams += part + encodeURIComponent(value) + "&";
        }
      }
    }
    urlparams = urlparams.slice(0, -1);
    url = urlparams;
  }
  url = baseUrl + url
  axios({
    method: method || 'post',
    url: url,
    responseType: 'blob',
    data: params,
    headers: { 'Authorization': 'Bearer ' + getToken() }
  }).then(res => {
    resolveBlob(res, mimeMap.docx)
    if (func && typeof func == 'function')
      func()
  })

}


export function downLoadExcel(url, params) {
  // get请求映射params参数
  if (params) {
    let urlparams = url + '?';
    for (const propName of Object.keys(params)) {
      const value = params[propName];
      var part = encodeURIComponent(propName) + "=";
      if (value !== null && typeof (value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            if (value[key] !== null && typeof (value[key]) !== 'undefined') {
              let params = propName + '[' + key + ']';
              let subPart = encodeURIComponent(params) + '=';
              urlparams += subPart + encodeURIComponent(value[key]) + '&';
            }
          }
        } else {
          urlparams += part + encodeURIComponent(value) + "&";
        }
      }
    }
    urlparams = urlparams.slice(0, -1);
    url = urlparams;
  }
  url = baseUrl + url
  axios({
    method: 'get',
    url: url,
    responseType: 'blob',
    headers: { 'Authorization': 'Bearer ' + getToken() }
  }).then(res => {
    console.log(res,222);
    resolveBlob(res, mimeMap.xlsx)
  })
}

/**
 * 解析blob响应内容并下载
 * @param {*} res blob响应内容
 * @param {String} mimeType MIME类型
 */
export function resolveBlob(res, mimeType, params) {
  const aLink = document.createElement('a')
  var blob = new Blob([res.data], { type: mimeType })
  var fileName = ''
  //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
  // console.log(res,'111111');
  var patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
  var contentDisposition = res.headers['content-disposition']
  // console.log(contentDisposition);
  // decodeURI
  if (contentDisposition !== undefined) {
    contentDisposition = decodeURI(contentDisposition)
    console.log(contentDisposition)
    var result = patt.exec(contentDisposition)
    fileName = result[1]
    fileName = fileName.replace(/\"/g, '')
    fileName = decodeURI(fileName)
  }
  aLink.style.display = 'none'
  aLink.href = URL.createObjectURL(blob)
  aLink.setAttribute('download', fileName) // 设置下载文件名称
  document.body.appendChild(aLink)
  aLink.click()
  URL.revokeObjectURL(aLink.href);//清除引用
  document.body.removeChild(aLink);
}
